import { createStore } from '../../util/createStore';
var store = createStore([]);
export function useGlobalStates() {
    var state = store.useStore()[0];
    return state;
}
export function autoSyncRecoil(_a) {
    var id = _a.id, recoil = _a.recoil;
    store.set(function (state) {
        state.push({ id: id, recoil: recoil });
    });
}
